import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import { FilerepoFile } from '@@api/services/metadata/schemas';
import config from '@@config';
import { ZImageTransformationsOutput } from '@@scripts/utils/buildImageTransformationUrl';

export const filerepoService = defineService(
    (defineEndpoint) => ({
        files: {
            postFile: defineEndpoint({
                method: 'POST',
                contentType: 'multipart/form-data',
                path: '/files',
                body: z.instanceof(FormData),
                responses: {
                    200: FilerepoFile,
                },
            }),
            postUrl: defineEndpoint({
                method: 'POST',
                path: '/files',
                body: z.union([
                    z.object({
                        assetId: z.string(),
                    }),
                    z.object({
                        url: z.string(),
                    }),
                ]),
                responses: {
                    200: FilerepoFile,
                },
            }),
            get: defineEndpoint({
                method: 'GET',
                path: '/metadata/elvisid/:id',
                pathParams: z.object({
                    id: FilerepoFile.shape.id,
                }),
                responses: {
                    200: FilerepoFile,
                },
            }),
            head: defineEndpoint({
                method: 'HEAD',
                path: '/files/:id/data',
                pathParams: z.object({
                    id: FilerepoFile.shape.id,
                }),
                query: ZImageTransformationsOutput,
                responses: {
                    200: z.never(),
                    404: z.never(),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.filerepoUrl,
    },
);
